import { LoadablePaint } from '@confluence/loadable';

export const PageLayout = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4-layout" */ './PageLayout.tsx')).PageLayout,
});
